<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            v-model="withDrawCredit.show"
            @hidden="closeModalWithDraw()"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12 text-center">
                            <h3 class="mb-0">การถอนเครดิต</h3>
                        </div>
                    </div>
                </div>
            </template>
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-lg-12 pt-2 pb-4">
                        <span class="alert-heading">
                            <Icon icon="clarity-wallet-solid" v-bind:style="{color: (this.$THEME.hasOwnProperty('primaryColor')) ? this.$THEME.primaryColor : '#11cdef'}" />
                            ยอดเครดิตที่ถอนได้ : ฿{{$WALLET.available_balance | numFormat('0,0.00')}}
                        </span>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group">
                            <h4>ระบุจำนวนเครดิต ( 1 เครดิต = 1 บาท)</h4>
                            <input
                                v-model="fillAmount"
                                type="number"
                                class="form-control hide-arrow"
                                placeholder="ขั้นต่ำ : 100 - 50,000"
                                :class="{ 'is-invalid': submitFormWithDraw && $v.fillAmount.$error }" 
                            />
                            <div v-if="submitFormWithDraw && !$v.fillAmount.required" 
                                class="invalid-feedback" >
                                กรุณากรอกจำนวนเงิน
                            </div>
                            <small v-if="submitFormWithDraw && !$v.fillAmount.between" class="text-danger">กรุณากรอกจำนวนเงินขั้นต่ำ 100 บาทและสูงสุดไม่เกิน 50000 บาท</small>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group">
                            <h4>รายละเอียดการถอน</h4>
                            <textarea
                                v-model="remarkWithDraw"
                                rows="3"
                                class="form-control"
                                placeholder="กรุณาระบุ รายละเอียดการถอน"
                                :class="{ 'is-invalid': submitFormWithDraw && $v.remarkWithDraw.$error }"
                            ></textarea>
                            <label
                                v-if="submitFormWithDraw && !$v.remarkWithDraw.required"
                                class="invalid-feedback"
                            >กรุณาระบุ รายละเอียดการถอน</label>
                        </div>
                    </div>
                    <div class="col-lg-12 text-right">
                        <b-button 
                            class="px-4 mx-2"
                            @click="closeModalWithDraw()"
                        >
                            ยกเลิก
                        </b-button>
                        <b-button 
                            class="px-4" 
                            variant="success" 
                            @click="withDrawCreditSP()"
                        >
                            <i class="fas fa-circle-notch fa-spin" v-if="isLoadingWithDraw"></i> ยืนยัน
                        </b-button>
                    </div>
                </div>
            </card>
            
        </b-modal>
    </div>
</template>
<script>
import { walletPayment } from "@/axios/walletPayment.js"
import {
    required,
    between
} from "vuelidate/lib/validators";
export default {
    name: "ModalWithDrawCredit" ,
    props: {
        withDrawCredit: Object,
    },
    data(){
        return{
            fillAmount:'',
            remarkWithDraw:'',
            isLoadingWithDraw: false,
            submitFormWithDraw: false
        }
    },
    validations:{
        fillAmount: { 
            required,
            between: between(100, 50000)
        },
        remarkWithDraw: { required }
    },
    mounted() {
    },
    methods:{
        closeModalWithDraw(){
            this.withDrawCredit.show = false
            this.fillAmount = ''
            this.remarkWithDraw = ''
        },
        withDrawCreditSP(){
            this.isLoadingWithDraw = true
            this.submitFormWithDraw = true
            this.$v.$touch();
            if( this.$v.$invalid ){
                this.isLoadingWithDraw = false
                return false
            }
            this.$http
                .post(
                this.$API_URL + "/wallet/agent/transaction/instant/withdraw",
                {
                    credit: this.fillAmount,
                    remark: this.remarkWithDraw
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                }
                )
                .then(res => {
                    let resData = res.data; 
                    this.isLoadingWithDraw = false
                    if(!resData.status){
                        if (resData.error.status === 405) {
                            this.showErrorModal('ยอดเงินไม่เพียงพอสำหรับการถอน', 'ปิด')
                        } else {
                            this.showErrorModal('ถอนเงินไม่สำเร็จ', 'ปิด')
                        }
                        return false;
                    }
                    this.showSuccessModal('ถอนเงินสำเร็จ')
                    this.closeModalWithDraw()
                    walletPayment().then( res => {
                        this.$WALLET.available_balance = res.available_balance
                        this.$WALLET.balance = res.balance
                        this.$WALLET.peg_balance = res.peg_balance
                        
                    })
                })
                .catch(error => {
                });
        },
        showSuccessModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "SUCCESS",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                okTitle: "ตกลง",
                contentClass: "modal-success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
        showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "ERROR",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: OkmsgTitle,
                contentClass: "modal-errors",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
    }
}
</script>
